// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vfGd","title":"styles_title__q_hTA"};